import { useAddToast } from '../../../../../contexts/ToastContext';
import { errorMessagesListFromResponse, type FailedFetchResponse } from '../../../../../helpers/errors';
import useAsyncValue from '../../../../../hooks/useAsyncValue';
import { get } from '../../../../../redux/api';
import { useAddJobToNotificationQueue } from '../../../../JobNotificationHub/Provider';

type ReportSnapshotsResponse = {
  task: {
    jobToken: string;
    task: string;
  };
};

/**
 * A hook for sending a weekly contributor report.
 */
const useContributors = () => {
  const { setPending, setResolve, setReject, isLoading } = useAsyncValue<ReportSnapshotsResponse>();
  const addToast = useAddToast();
  const addJob = useAddJobToNotificationQueue();

  const sendContributorsReport = async () => {
    setPending();
    try {
      const { data, status } = await get<ReportSnapshotsResponse>('/api/contributors/report-snapshots');
      if (data) {
        setResolve(data);
      }

      if (status === 201) {
        addToast({ content: 'Report will be emailed to you within a few hours.', type: 'success' });
        if (data?.task) {
          addJob(data.task.jobToken, data.task.task);
        }
      } else {
        addToast({ content: 'Failed to send weekly contributor report.', type: 'error' });
      }
    } catch (error) {
      setReject(errorMessagesListFromResponse(error as FailedFetchResponse));
      addToast({ content: 'Failed to send weekly contributor report.', type: 'error' });
    }
  };

  return {
    sendContributorsReport,
    isLoading,
  };
};

export default useContributors;
